import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import Stepper from 'bs-stepper';
import { AppConstants } from 'src/app/app.constants';
import { FormService } from 'src/app/services/form.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UtilsService } from 'src/app/services/utils.service';
import { VotacionService } from 'src/app/services/votacion.service';
import { VotanteService } from 'src/app/services/votante.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-resultados-publico',
  templateUrl: './resultados-publico.component.html',
  styleUrls: ['./resultados-publico.component.css']
})
export class ResultadosPublicoComponent implements OnInit, AfterViewInit {

  modulo: any = AppConstants.APLICATION_MODULES.RESULTADOS_PUBLICO;
  nombreSistema: String = environment.ENVIRONMENT.NOMBRE_SISTEMA;
  descripcionSistema: String = environment.ENVIRONMENT.DESCRIPCION_SISTEMA;
  ambienteSistema: String = environment.ENVIRONMENT.AMBIENTE;
  versionSistema: String = environment.ENVIRONMENT.VERSION;

  form: FormGroup;
  submitted: Boolean = false;
  stepperForm: Stepper;

  token: any;
  votacion: any;
  listaPreguntas: any;
  tablaVotos: any;
  linkVotos: string;
  tablaVotantes: any;
  linkVotantes: string;

  constructor(private formService: FormService, private route: ActivatedRoute, private modal: ModalService,
    private utils: UtilsService, private alert: NotificacionesService, private votacionService: VotacionService,
    private votanteService: VotanteService) {
    this.votacion = { tituloVotacion: '', votosRecibidos: '' };
    this.tablaVotos = this.utils.inicializarTablaPaginado();
    this.linkVotos = '';
    this.tablaVotantes = this.utils.inicializarTablaPaginado();
    this.linkVotantes = '';
  }

  ngOnInit(): void {
    this.modal.mostrarModalCargando();
    this.form = this.formService.getVerResultadosForm();
    this.route.queryParams.subscribe((params: Params) => this.token = params['token']);
    this.modal.cerrarModalCargando();
    if (!this.utils.validarString(this.token)) {
      this.alert.warning('Para acceder al módulo de ver resultados es necesario proporcionar el token de la votación enviado a su correo electrónico', true);
      this.utils.redirectPath([AppConstants.APLICATION_MODULES.INICIO.ruta]);
    } else {
      let datosUsuario = this.utils.obtenerDatosUsuario();
      if (this.utils.validarObjeto(datosUsuario) && this.utils.validarString(datosUsuario.usuario)) {
        let ruta = AppConstants.APLICATION_SUBMODULES.VOTACIONES_VER_RESULTADOS.menu.ruta + '/' + AppConstants.APLICATION_SUBMODULES.VOTACIONES_VER_RESULTADOS.ruta + '?token=' + this.token;
        this.utils.redirectPathWindow(ruta, true);
      } else {
        this.loadDatosVotacion();
      }
    }
  }

  loadDatosVotacion() {
    this.modal.mostrarModalCargando();
    this.votacionService.obtenerVotacionToken(this.token).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.votacion = data.votacion;
        this.form = this.formService.getVerResultadosForm(this.votacion);
        this.listaPreguntas = [];
        this.tablaVotantes = this.utils.inicializarTablaPaginado();
        this.loadTablaPreguntas(false);
        this.loadTablaVotos(false);
        this.loadTablaVotantes(false);
        this.modal.cerrarModalCargando();
      } else {
        console.error('Error', data.mensaje);
        this.listaPreguntas = [];
        this.tablaVotos = this.utils.inicializarTablaPaginado();
        this.tablaVotantes = this.utils.inicializarTablaPaginado();
        this.modal.cerrarModalCargando();
        this.alert.error('Para acceder al módulo de ver resultados es necesario proporcionar el token de la votación enviado a su correo electrónico', true);
        this.utils.redirectPath([AppConstants.APLICATION_MODULES.INICIO.ruta]);
      }
    }, (error: any) => {
      console.error('Error', error);
      this.listaPreguntas = [];
      this.tablaVotos = this.utils.inicializarTablaPaginado();
      this.tablaVotantes = this.utils.inicializarTablaPaginado();
      this.modal.cerrarModalCargando();
      this.alert.error('Error al cargar la información de la votación, intente de nuevo', true);
      this.utils.redirectPath([AppConstants.APLICATION_MODULES.INICIO.ruta]);
    });
  }

  loadTablaPreguntas(showModalCargando?) {
    showModalCargando = this.utils.validarObjeto(showModalCargando) ? showModalCargando : true;
    if (showModalCargando)
      this.modal.mostrarModalCargando();
    this.votacionService.obtenerResultadosVotacionToken(this.token).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.listaPreguntas = data.preguntas;
        this.listaPreguntas.map((pregunta) => {
          let mayorVotacion = Math.max(...pregunta.opciones.map((o) => o.resultado), 0);
          let ganadores = pregunta.opciones.filter(opcion => {
            return opcion.resultado === mayorVotacion;
          });
          pregunta.ganadores = ganadores;
          pregunta.claseGanadores = pregunta.ganadores.length > 1 ? 'empate' : 'ganador';
        });
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      } else {
        this.listaPreguntas = [];
        if (showModalCargando)
          this.modal.cerrarModalCargando();
      }
    }, (error: any) => {
      this.alert.error('Error al cargar la lista de preguntas, intente de nuevo', true);
      this.listaPreguntas = [];
      console.error('Error', error);
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    });
  }

  loadTablaVotos(showModalCargando?, linkVotos?) {
    showModalCargando = this.utils.validarObjeto(showModalCargando) ? showModalCargando : true;
    this.linkVotos = linkVotos;
    let promesa;
    if (this.utils.validarString(linkVotos)) {
      promesa = this.votacionService.obtenerPaginaLink(linkVotos);
    } else {
      this.tablaVotos.hrefComplemento = '&idVotacion=' + this.votacion.idVotacion + '&numeroRastreo=' + this.form.value.numeroRastreo;
      promesa = this.votacionService.obtenerPaginaVotos2(this.tablaVotos.paginaDefault, this.tablaVotos.tamanioPagina, this.votacion.idVotacion, this.form.value.numeroRastreo);
    }
    if (showModalCargando)
      this.modal.mostrarModalCargando();
    promesa.subscribe((data: any) => {
      this.tablaVotos = this.utils.procesarPaginado(this.tablaVotos, data, true, environment.REST_API.PAGINADO_URL_REEMPLAZAR, environment.REST_API.PAGINADO_URL_REEMPLAZO, true);
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    }, (error: any) => {
      this.alert.error('Error al cargar la lista de votos, intente de nuevo', true);
      console.error('Error', error);
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    });
  }

  loadTablaVotantes(showModalCargando?, linkVotantes?) {
    showModalCargando = this.utils.validarObjeto(showModalCargando) ? showModalCargando : true;
    this.linkVotantes = linkVotantes;
    let promesa;
    if (this.utils.validarString(linkVotantes)) {
      promesa = this.votanteService.obtenerPaginaLink(linkVotantes);
    } else {
      this.tablaVotantes.hrefComplemento = '&idVotacion=' + this.votacion.idVotacion + '&correoElectronico=' + this.form.value.correoParticipante;
      promesa = this.votanteService.obtenerPaginaVotantes2(this.tablaVotantes.paginaDefault, this.tablaVotantes.tamanioPagina, this.votacion.idVotacion, this.form.value.correoParticipante);
    }
    if (showModalCargando)
      this.modal.mostrarModalCargando();
    promesa.subscribe((data: any) => {
      this.tablaVotantes = this.utils.procesarPaginado(this.tablaVotantes, data, true, environment.REST_API.PAGINADO_URL_REEMPLAZAR, environment.REST_API.PAGINADO_URL_REEMPLAZO, true);
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    }, (error: any) => {
      this.alert.error('Error al cargar la lista de votantes, intente de nuevo', true);
      console.error('Error', error);
      if (showModalCargando)
        this.modal.cerrarModalCargando();
    });
  }

  next() {
    this.stepperForm.next();
  }

  previous() {
    this.stepperForm.previous();
  }

  ngAfterViewInit() {
    this.stepperForm = new Stepper(document.querySelector('#stepperForm'), {
      linear: false,
      animation: true
    });
  }

  onSubmit() {
    return false;
  }

  redirectInicio(): void {
    this.utils.redirectPathWindow(AppConstants.APLICATION_MODULES.INICIO.ruta);
  }

}
